import React, {Component, Fragment} from "react";
import ProgressBar from "../../../components/ProgressBar";

/** Example 80% */
class ExampleProgressBar80 extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		return (
			<Fragment>
				<ProgressBar percent={80} width={150}/>
			</Fragment>
		);
	}
}

export default ExampleProgressBar80;
